enum MockAvatars {
  default = 'https://media-exp1.licdn.com/dms/image/C560BAQHMjfT2f8er3g/company-logo_200_200/0?e=2159024400&v=beta&t=MXopmOSyhjAHOFbVpoKEs5B6xN0-2anecZi_VqtNBug',
}
export default MockAvatars;
